<div class="radio-container" [class.inactive]="disabled">
  <input
    type="radio"
    [name]="name"
    [checked]="selected"
    [disabled]="disabled"
    (change)="onChange($event)"
  />
  <hyperkit-typography class="label" variant="label1">{{ text }}</hyperkit-typography>
</div>
